import { render, staticRenderFns } from "./FBAoderedit.vue?vue&type=template&id=daa05a40&scoped=true&"
import script from "./FBAoderedit.vue?vue&type=script&lang=js&"
export * from "./FBAoderedit.vue?vue&type=script&lang=js&"
import style0 from "./FBAoderedit.vue?vue&type=style&index=0&id=daa05a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa05a40",
  null
  
)

export default component.exports